import { UpdateUserActions } from 'app/components/shared/UpdateUserActions'
import { Base } from 'app/components/ui/Base'
import { BgRetina } from 'app/components/ui/BgRetina'
import { Button } from 'app/components/ui/Button'
import { Container } from 'app/components/ui/Container'
import { Image } from 'app/components/ui/Image'
import { LoadingSpinner } from 'app/components/ui/LoadingSpinner'
import { Separator } from 'app/components/ui/Separator'
import { Text } from 'app/components/ui/Text'
import { Title } from 'app/components/ui/Title'
import { useAuth } from 'app/contexts/AuthenticationProvider'
import { useLayout } from 'app/contexts/LayoutProvider'
import { useGetAllSponsorRequests } from 'app/queries/sponsorRequests'
import { protectedRoutes } from 'app/routing/routes'
import React, { useLayoutEffect } from 'react'
import { useErrorHandler } from 'react-error-boundary'
import { useHistory } from 'react-router-dom'
import styled, { useTheme } from 'styled-components'

import { SponsorRequestsTable } from './SponsorRequestsTable'

export const Dashboard = (): JSX.Element => {
  const { push } = useHistory()

  const { updateLayoutData } = useLayout()
  const theme = useTheme()
  const { user } = useAuth()

  const { data: sponsorRequests, error, isLoading } = useGetAllSponsorRequests()

  useLayoutEffect(() => {
    updateLayoutData({
      title: 'Area Sponsor Marketing',
      subTitle:
        'Benvenuto nella tua area dedicata! Qui trovi tutte le tue richieste di sponsorizzazione.',
      headerVariant: 'dashboard',
    })
  }, [updateLayoutData])

  useErrorHandler(error)

  if (isLoading) return <LoadingSpinner />

  return (
    <>
      {user?.sponsorman.status === 'rejected' && (
        <Banner>
          <UpdateUserActions>
            <Title size={3}>Anagrafica Rifiutata</Title>
            <Text variant='s16' mt={1}>
              La tua anagrafica è stata rifiutata
              {user?.sponsorman.pdf_registry_notes
                ? ` per il seguente motivo:\n ${user?.sponsorman.pdf_registry_notes}`
                : '.'}
            </Text>
          </UpdateUserActions>
          <BannerSeparator />
        </Banner>
      )}
      <Base paddingBottom={0} paddingBottomMobile={0}>
        <HeaderContainer>
          <Title size={3}>Le tue richieste di sponsorizzazione</Title>
          {sponsorRequests?.length ? (
            <Text variant='s20' mt={2}>
              Clicca sull’oggetto della richiesta per vederne il dettaglio
            </Text>
          ) : null}
        </HeaderContainer>
      </Base>
      <Base paddingTop={0}>
        <BgRetina
          bgPosition='top'
          bgImage='https://res.cloudinary.com/estra/image/upload/v1630331433/estra20dev/sponsor/dashbord/sponsor_requests_bg.svg'
        >
          <SponsorRequestsContainer>
            {sponsorRequests?.length ? (
              <SponsorRequestsTable
                sponsorRequests={sponsorRequests}
                onAddSponsorRequest={() =>
                  push(protectedRoutes.sponsorRequestCreate.path)
                }
              ></SponsorRequestsTable>
            ) : (
              <EmptyRequestsWrapper>
                <Image
                  src='https://res.cloudinary.com/estra/image/upload/v1630046896/estra20dev/sponsor/no_sponsor_requests.svg'
                  alt='no_requests'
                ></Image>
                <Title
                  size={4}
                  mt={2}
                  mb={2}
                  color={theme.color.primari.grigioEstra}
                >
                  Non hai ancora richieste di sponsorizzazione da visionare.
                </Title>
                <Button
                  variant={'black'}
                  onClick={() =>
                    push(protectedRoutes.sponsorRequestCreate.path)
                  }
                >
                  Aggiungi una richiesta
                </Button>
              </EmptyRequestsWrapper>
            )}
          </SponsorRequestsContainer>
        </BgRetina>
      </Base>
    </>
  )
}

const Banner = styled(Container)`
  padding-top: 3rem;
  text-align: center;
`
const BannerSeparator = styled(Separator)`
  margin-top: 2rem;
`

const HeaderContainer = styled(Container)`
  text-align: center;
`

const SponsorRequestsContainer = styled(Container)`
  @media (min-width: ${({ theme }) => theme.bp.tablet}) {
    min-height: 500px;
  }
`

const EmptyRequestsWrapper = styled.div`
  text-align: center;
`
